export const PLATFORMS = {
  telegram: { id: 'telegram', label: 'Telegram' },
  max: { id: 'max', label: 'MAX' },
};

export function getIdentity(user, provider) {
  return getIdentities(user).find((item) => item.provider === provider) ?? null;
}

export function getIdentities(user) {
  if (!user) {
    return [];
  }
  // Prefer /me nested user (type: "user", user: { identities }) over a stale top-level field.
  if (user.user && Array.isArray(user.user.identities)) {
    return user.user.identities;
  }
  if (Array.isArray(user.identities)) {
    return user.identities;
  }
  return [];
}

export function getProviderUserId(user, provider) {
  return getIdentity(user, provider)?.provider_user_id ?? null;
}

export function getUserId(user) {
  return user?.user?.id || user?.id || null;
}

export function getUserProfile(user) {
  return user?.user || user || null;
}

export function formatIdentityLabel(identity) {
  const label = PLATFORMS[identity.provider]?.label ?? identity.provider;
  const username = identity.username ? ` (@${identity.username})` : '';
  return `${label}: ${identity.provider_user_id}${username}`;
}

export function getOtherProviders(currentProvider) {
  return Object.keys(PLATFORMS).filter((id) => id !== currentProvider);
}
